import { render } from "./Model.vue?vue&type=template&id=ea024558"
import script from "./Model.vue?vue&type=script&lang=js"
export * from "./Model.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@5.9.3__webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__